import { Text } from 'component-library';
import React from 'react';

export const IncomeReductionInfo = () => {
  return (
    <Text>This credit will reduce your income taxes when you file them.</Text>
  );
};
